import script from "./CellTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CellTable.vue?vue&type=script&setup=true&lang=js"

import "./CellTable.vue?vue&type=style&index=0&id=617c2331&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-617c2331"]])

export default __exports__